TS.ns('WL');

WL.adminApplicationModel = new Class({
    Extends: TS.domain.EditDomain,

    createProperties: function (config) {
        var me = this;

        me.parent(config);

        var applicationThemeList = me.getDomainProperty('lkpApplicationTheme_Property');
        if (applicationThemeList != null) {
            applicationThemeList.on('selectionChanged', me.onApplicationThemeChanged, me);
        }

    },

    onApplicationThemeChanged: function (newValue) {
        var me = this;  

        me.performServerCommand({ cmd: 'ChangeApplicationTheme', submitModel: true, extraData: { ApplicationThemeId : newValue.record.DictionaryItemId }, blockUI: true });
    }
});